import Vue from 'vue'
import { mapGetters } from 'vuex'
var tinycolor = require('tinycolor2')
import { baseURL } from '../services/index'
// Object mixin for functions globals in the system
export let globals = {
  data() {
    return {
      logoCompany: null
    }
  },
  computed: {
    ...mapGetters({
      dateFormatDefault: 'company/getdateFormatDefault'
    })
  },
  methods: {
    calculateColor(color) {
      return tinycolor(color).isDark()
    },
    codification({ mode = 'encode', code }) {
      switch (mode) {
        case 'decode':
          return this.$CryptoJS.AES.decrypt(
            String(code),
            'Iprintpos Graphic v2 stand@rd'
          ).toString(this.$CryptoJS.enc.Utf8)
        default:
          return this.$CryptoJS.AES.encrypt(
            String(code),
            'Iprintpos Graphic v2 stand@rd'
          ).toString()
      }
    },
    dateFormat(date) {
      if (date) {
        let ndate = date.indexOf('-') !== -1 ? date.split('-') : date.split('/')
        if (this.dateFormatDefault === 'dd-mm-yyyy') {
          return `${ndate[2]}-${ndate[1]}-${ndate[0]}`
        }
        if (this.dateFormatDefault === 'mm-dd-yyyy') {
          return `${ndate[1]}-${ndate[2]}-${ndate[0]}`
        }
        if (this.dateFormatDefault === 'yyyy-mm-dd') {
          return `${ndate[0]}-${ndate[1]}-${ndate[2]}`
        }
        return date
      }
      return ''
    },
    timeFormat(datetime) {
      var dt = new Date(`${datetime.date} ${datetime.time.split('.')[0]}`)
      dt.setMinutes(dt.getMinutes() - new Date().getTimezoneOffset())
      return `${dt.getHours()}:${
        dt.getMinutes() < 10 ? '0' + dt.getMinutes() : dt.getMinutes()
      }`
    },
    showImage(url = null) {
      if (url === null || url === '') {
        return require('@/assets/default_image.png')
      }

      let newUrl = url
      if (url.indexOf('http') == -1 && url.indexOf('/sources/') != -1) {
        newUrl = baseURL.split('/api/')[0].concat(newUrl)
      }
      if (
        url.indexOf('http') === -1 &&
        url.indexOf('/sources/') === -1 &&
        url.indexOf(';base64') === -1
      ) {
        newUrl = baseURL.split('/api/')[0].concat(`/sources/${url}`)
      }
      return newUrl
    },
    async downloadFile({
      api = '',
      method = 'pdf',
      filename = '',
      action = 'download',
      ext = 'pdf',
      opt = {}
    }) {
      let query = this.$api
      api.split('.').forEach((element) => (query = query[element]))
      try {
        let response = await query[method](opt)
        const url = window.URL.createObjectURL(response.data)
        if (action === undefined || action === 'window') {
          if (ext === 'pdf') {
            window.open(url, `${filename}.pdf`)
          } else {
            window.open(url, `${filename}`)
          }
        } else {
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `${filename}.${ext}`)
          document.body.appendChild(link)
          link.click()
        }
      } catch (error) {
        const msg = this.$te('error_generating_pdf')
          ? this.$t('error_generating_pdf')
          : 'Error al generar el PDF'
        this.$toast.error(msg)
        return false
      }
    }
  }
}
Vue.mixin(globals)
